import { render, staticRenderFns } from "./warehouseVetPrescription.vue?vue&type=template&id=1647c355&scoped=true&"
import script from "./warehouseVetPrescription.vue?vue&type=script&lang=js&"
export * from "./warehouseVetPrescription.vue?vue&type=script&lang=js&"
import style0 from "./warehouseVetPrescription.vue?vue&type=style&index=0&id=1647c355&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647c355",
  null
  
)

export default component.exports